import ApiSdk from 'services/callApi'
import {Component} from 'react'
import TradeView from 'components/TradeView'
import {__PROD__, SITE_TITLE} from 'constants'
import {trim} from 'utils/format'
import Layout from './layout'

export default class FuturesPage extends Component {
  static async getInitialProps (ctx) {
    try {
      const {lng = 'en'} = ctx.query || {}
      const futuresI18n = await ApiSdk.common.getI18nInfo(!__PROD__, 'futures-ui', lng)
      const i18n = {}
      Object.entries(futuresI18n).forEach(item => {
        let [key, val] = item

        key = key.replace('futures-trade-', '')
        i18n[key] = trim(val)
      })

      return {
        i18n
      }
    } catch {
      return {i18n: {}}
    }
  }

  render () {
    const {i18n = {}} = this.props
    return (
      <Layout metaData={{title: SITE_TITLE}}>
        <TradeView i18n={i18n} />
      </Layout>
    )
  }
}
